const getStringInSnakeCase = (caption) =>
  caption.toLowerCase().split(' ').join('_');

export default getStringInSnakeCase;
